<template>
  <div class="p-6 bg-white rounded-tr-3xl rounded-bl-3xl rounded-br-3xl shadow-[8px_16px_40.5px_0px_rgba(15,33,47,0.06),_-3px_1px_30px_0px_rgba(15,33,47,0.05)] inline-flex flex-col gap-4 items-start">
    <div class="text-sky-600 roboto-condensed text-4xl font-medium leading-[48px]">
      <span v-if="prefix">{{ prefix }}</span>
      {{ formattedCount }}
      <span v-if="suffix">{{ suffix }}</span>
    </div>
    <div class="text-neutral-700 roboto text-lg font-normal leading-5">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CountUp",

  props: {
    target: {
      type: Number,
      required: true
    },
    prefix: {
      type: String,
      default: ''
    },
    suffix: {
      type: String,
      default: ''
    },
    disableAnimation: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 2000
    }
  },

  data() {
    return {
      displayCount: 0,
      hasAnimated: false
    };
  },

  computed: {
    decimals() {
      const parts = this.target.toString().split('.');
      return parts[1] ? parts[1].length : 0;
    },

    formattedCount() {
      return this.displayCount.toLocaleString('nl-NL', {
        minimumFractionDigits: this.decimals,
        maximumFractionDigits: this.decimals
      });
    }
  },

  mounted() {
    if (!this.disableAnimation) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !this.hasAnimated) {
              this.startAnimation();
              this.hasAnimated = true;
              observer.unobserve(this.$el); // run only once
            }
          });
        },
        {
          threshold: 1 // start when 100% visible
        }
      );

      observer.observe(this.$el);
    } else {
      this.displayCount = this.target;
    }
  },

  methods: {
    startAnimation() {
      const startTime = performance.now();
      const numericTarget = this.target;

      const animate = (currentTime) => {
        const progress = Math.min(
          (currentTime - startTime) / this.duration,
          1
        );

        const currentValue = progress * numericTarget;

        const factor = Math.pow(10, this.decimals);
        this.displayCount =
          Math.round(currentValue * factor) / factor;

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          this.displayCount = numericTarget;
        }
      };

      requestAnimationFrame(animate);
    }
  }
};
</script>
